var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechSingle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.27 53.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#3b3b39;stroke-miterlimit:10;stroke-width:0.55px;}.cls-2{fill:#3b3b39;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ex_2",
    "data-name": "ex 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "45.07 14.56 45.07 39.31 43.18 40.4 25.5 50.61 23.63 51.69 21.68 50.57 4.09 40.41 2.19 39.31 2.19 14.56 4.09 13.46 23.63 2.19 43.18 13.47 45.07 14.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "2.19 39.31 2.29 39.25 4.15 40.32 21.74 50.47 23.73 51.62"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 23.58,
    cy: 51.65,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 23.58,
    cy: 2.19,
    r: 2.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.38,39.31a2.16,2.16,0,0,1-.25,1,.47.47,0,0,1-.06.09A2.16,2.16,0,0,1,2.19,41.5,2.13,2.13,0,0,1,.3,40.39h0a2.18,2.18,0,0,1,1.88-3.27h0A2.19,2.19,0,0,1,4.38,39.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.4,14.56a2.19,2.19,0,0,1-2.19,2.19h0A2.19,2.19,0,0,1,0,14.56a2.09,2.09,0,0,1,.3-1.08,2.15,2.15,0,0,1,1.89-1.11,2.14,2.14,0,0,1,1.88,1.09A2.07,2.07,0,0,1,4.4,14.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.27,39.31a2.16,2.16,0,0,1-.25,1,.41.41,0,0,1-.05.09,2.19,2.19,0,0,1-3.79,0,2.11,2.11,0,0,1-.29-1.09,2.19,2.19,0,0,1,2.18-2.19h0A2.19,2.19,0,0,1,47.27,39.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.26,14.56a2.19,2.19,0,0,1-2.19,2.19h0a2.19,2.19,0,0,1-2.18-2.19,2.11,2.11,0,0,1,.29-1.09,2.19,2.19,0,0,1,3.79,0A2.16,2.16,0,0,1,47.26,14.56Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechSingle);
export default __webpack_public_path__ + "static/media/tech-single.af82cc0f61eaa6589f41925159eb5460.svg";
export { ForwardRef as ReactComponent };